<template>
  <div>
    <v-row>
      <v-col cols="10" class="pt-0 pb-2 text-body-2 text--secondary">
        {{ title }}
      </v-col>
      <v-col cols="2" class="pt-0 pb-2 text-right text-body-2">
        <v-tooltip v-if="info" left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon class="text-body-2 text--secondary" v-bind="attrs" v-on="on">mdi-alert-circle</v-icon>
          </template>
          <span>{{ info }}</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0 pb-0">
        <slot></slot>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data: () => ({
  }),
  props: ["title", "info"],
};
</script>
